import {REDIRECT_SHARE_URL} from './constants';

export const redirectShareLink = (medium, linkOptions, shareText) => {
    const {source, resource_type, resource_id, is_resource_owner} = linkOptions;
    const text = `&share_text=${shareText ? encodeURIComponent(shareText) : ''}`;

    return `${REDIRECT_SHARE_URL}?source=${source}&medium=${medium}&resource_type=${resource_type}&resource_id=${resource_id}&is_resource_owner=${is_resource_owner}${text}`;
};




// WEBPACK FOOTER //
// ./src/utils/redirectShareLink.js